import { render, staticRenderFns } from "./WagesAuth.vue?vue&type=template&id=14bbc147&"
import script from "./WagesAuth.vue?vue&type=script&lang=js&"
export * from "./WagesAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports